<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/O9Xo8g/tc-custom/9781601637338.jpg?1726518856659" alt="This image is the cover for the book Purpose-Guided Universe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Purpose-Guided Universe
      </h1>
      <p class="bookDescription body article font2">
        <b>“If you think that science has nothing to do with God, and vice versa, read this book—and you just may change your mind.” —Professor Peter Sturrock, Dept. Physics, Stanford University</b><br/><br/>In this engrossing new book, Dr. Bernard Haisch contends that there is a purpose and an underlying intelligence behind the Universe, one that is consistent with modern science, especially the Big Bang and evolution. It is based on recent discoveries that there are numerous coincidences and fine-tunings of the laws of nature that seem extraordinarily unlikely.<br/><br/>A more rational concept of God is called for. As astrophysicist Sir James Jeans wrote, “the Universe begins to look more like a great thought than like a great machine.”<br/><br/>Despite bestsellers by Christopher Hitchens, Richard Dawkins, and Sam Harris that have denounced the evils of religion and proclaimed that science has shown that there is no God, <i>The Purpose-Guided Universe</i> shows how one can believe in God and science.<br/><br/>“Committed atheists, traditional Christians, or hard-core Muslims will no doubt try to dismiss this book . . . provocative.” —Prof. Owen Gingerich, Harvard-Smithsonian Center for Astrophysics, author, <i>God’s Universe</i><br/><br/>“Neither science nor theology can consider itself informed without taking into account Haisch’s views.” —Larry Dossey, MD, author, <i>Healing Words</i><br/><br/>“Merits being read and pondered by everyone seeks deeper meaning underlying science’s ever more astounding view of the world.” —Dr. Ervin Laszlo, author, Science and the Akashic Field<br/><br/>“An enlightening exploration.” —Julia Ann Charpentier, <i>ForeWord</i> Reviews<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bernard Haisch
      </h2>
      
      <p class="authorDescription body article">Bernard Haisch, PhD, is an astrophysicist and author of The God Theory and more than 130 scientific publications. He was a scientific editor of the Astrophysical Journal for 10 years. His professional positions include deputy director of the Center for Extreme Ultraviolet Astrophysics at U.C.-Berkeley; and visiting scientist at the Max-Planck-Institute für Extraterrestrische Physik in Garching, Germany. He was also editor in chief of the Journal of Scientific Exploration. Prior to his career in astrophysics, Haisch attended the St. Meinrad Seminary as a student for the Catholic priesthood. He lives in the San Francisco Bay Area with his wife, Marsha Sims and his three children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Page Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18d6f717